import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import BackIcon from "../assets/icons/BackIcon";
import PlusIcon from "../assets/icons/PlusIcon";
import CheckIcon from "../assets/icons/CheckIcon";
import { useAppDispatch, useAppSelector } from "../hooks";
import { getCartState } from "../store";
import DeleteIcon from "../assets/icons/DeleteIcon";
import { clearProductInCart } from "../store/slices/cartSlice";
import { addressPrvSliceActions } from "../store/slices/addressSlice";
import { IFormInfoOrderPayload } from "../types/order";
import { orderPrvSliceActions, setOrderInfo } from "../store/slices/orderSlice";
import { getCookie, removeCookie } from "../helpers/handleCookie";
import { clearCart } from "../store/slices/cartSlice";
import LoadingIcon from "../assets/icons/LoadingIcon";
import CloseIcon from "../assets/icons/CloseIcon";
import GiftIcon from "../assets/icons/GiftIcon";
import { discountPrvSliceActions } from "../store/slices/discountSlice";
import { shipPrvSliceActions } from "../store/slices/shipSlice";
import { toast } from "react-toastify";
import { log } from "node:console";
import { getCartItemUnitPrice } from "../helpers/handleProduct";
export default function CheckoutPage() {
  const navigate = useNavigate();
  const { cartInfo } = useAppSelector(getCartState);
  const [discountCode, setDiscountCode] = useState<string>();
  const [errorDiscount, setErrorDiscount] = useState<string>();
  const [extraPrice, setExtraPrice] = useState<number>(0);
  const [priceDiscount, setPriceDiscount] = useState<number>(0);
  const [provinceList, setProvinceList] = useState<any>();
  const [districtList, setDistrictList] = useState<any>();
  const [wardList, setWardList] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isExportInvoice, setIsExportInvoice] = useState<boolean>(false);
  const [isLoadingDiscount, setIsLoadingDiscount] = useState<boolean>(false);
  const [isApplyDiscount, setIsApplyDiscount] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const {
    register,
    reset,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInfoOrderPayload>({ mode: "onBlur" });

  const totalPrice: number = useMemo(() => {
    return cartInfo.reduce(
      (accumulator, currentValue) => {
        const unitPrice = getCartItemUnitPrice(currentValue);
        return accumulator + unitPrice * currentValue.quantity;
      },
      0
    );
  }, [cartInfo]);
  const baseTotalPrice: number = useMemo(() => {
    return cartInfo.reduce(
      (accumulator, currentValue) =>
        accumulator + currentValue.price_sale * currentValue.quantity,
      0
    );
  }, [cartInfo]);
  const showBaseTotal = baseTotalPrice > totalPrice;

  useEffect(() => {
    const coupon = getCookie('coupon');
    if (!!coupon) {
      setDiscountCode(prev => prev = coupon);
      setIsApplyDiscount(true);
      handleCalculateDiscount(coupon);
    }
    const fetchProvinces = async () => {
      const res = await dispatch(addressPrvSliceActions.getProvinceList());
      setProvinceList((prev: any) => (prev = res.payload));
    };
    fetchProvinces();
  }, [dispatch]);
  // const fetchDistricts = async () => {
  //   const res = await dispatch(
  //     addressPrvSliceActions.getDistrictList(getValues("province_id"))
  //   );
  //   setDistrictList((prev: any) => (prev = res.payload));
  // };

  const fetchWards = async () => {
    const res = await dispatch(
      addressPrvSliceActions.getWardList(getValues("province_id"))
    );

    setWardList((prev: any) => (prev = res.payload));
  };
  useEffect(() => {
    const productPayload = cartInfo
      .filter(item => item.type === "product")
      .map((product) => {
        const unitPrice = getCartItemUnitPrice(product);
        return {
          product_id: product.id,
          product_name: product.name,
          price_sale: unitPrice,
          quantity: product.quantity,
        };
      });
    const comboPayload = cartInfo
      .filter(item => item.type === "combo")
      .map((product) => {
        return {
          combo_id: product.id,
          combo_name: product.name,
          price_sale: product.price_sale,
          quantity: product.quantity,
        };
      });
    const totalPay = priceDiscount < 100
      ? totalPrice - (totalPrice * priceDiscount / 100) + extraPrice
      : totalPrice - priceDiscount + extraPrice;
    setValue("discount", priceDiscount < 100 ? totalPrice * priceDiscount / 100 : priceDiscount);
    setValue("products", productPayload);
    setValue("combos", comboPayload);
    setValue("total_price", totalPrice);
    setValue("total_pay", totalPay);
    setValue("type_link", 1);
    setValue("channel", "Store");

  }, [cartInfo, dispatch, priceDiscount, extraPrice, totalPrice, setValue]);

  const handleCalculateDiscount = async (code: string | undefined) => {
    setIsLoadingDiscount(true);
    const products = cartInfo.map(product => {
      const unitPrice = getCartItemUnitPrice(product);
      return {
        product_id: product.id,
        product_name: product.name,
        price: unitPrice,
        quantity: product.quantity,
      }
    });
    const res = await dispatch(discountPrvSliceActions.calculateDiscount({
      code: code,
      products: products
    }))
    setIsLoadingDiscount(false);
    if (!res.payload.error) {
      setErrorDiscount('');
      setPriceDiscount(prev => prev = parseInt(res.payload.coupon_discount));
      setIsApplyDiscount(true);
      return;
    }
    setErrorDiscount(prev => prev = res.payload.msg || '');
    setPriceDiscount(prev => prev = 0);
    removeCookie('coupon');
  }
  const onSubmit = handleSubmit(async (data) => {
    const ref = getCookie("ref");
    const refSub = getCookie("ref_sub");
    const src = getCookie("src");

    
  // Bóc riêng province_id & ward_id rồi lấy phần còn lại
    const { province_id, ward_id, ...rest } = data as any;
    const payload = {
      ...rest,
      ref: ref,
      ref_sub: refSub,
      src: src,
      province_code: province_id, // ánh xạ
      ward_code: ward_id,          // ánh xạ
      vat_id: isExportInvoice ? Number(data.vat_id) : null,
      vat_name: isExportInvoice ? data.vat_name : null,
    }
    // Xóa 2 key cũ
    dispatch(setOrderInfo(payload));
    setIsLoading((prev) => (prev = true));
    const res = await dispatch(orderPrvSliceActions.createOrder(payload))
    setIsLoading((prev) => (prev = false));
    if (res.payload.status === 1 && res.payload.data && res.payload.data.checkout_url) {
      window.location = res.payload.data.checkout_url;
      reset();
      dispatch(clearCart());
    }
    else if (res.payload.order_id) {
      reset();
      dispatch(clearCart());
      navigate("/checkout/thank-you");
    }
    else {
      toast.error(res.payload.msg)
    }
  });
  const handleCalculateShippingPrice = async (address: any) => {
    const maxHeight = Math.max(...cartInfo.map(product => Number(product.package_height)));
    const sumLength: number = cartInfo.reduce((accumulator, currentValue) => accumulator + +currentValue.package_length, 0);
    const sumWidth: number = cartInfo.reduce((accumulator, currentValue) => accumulator + +currentValue.package_length, 0);
    const sumWeight: number = cartInfo.reduce((accumulator, currentValue) => accumulator + +currentValue.weight, 0);
    if (!address && sumWeight === 0) return;
    const payload = {
      to_province_id: getValues("province_id"),
      to_district_id: getValues("district_id"),
      to_ward_id: getValues("ward_id"),
      to_address: address,
      height: maxHeight || 1,
      sum_length: sumLength || 1,
      sum_width: sumWidth || 1,
      sum_weight: sumWeight || 0,
      process_type: 1,
      total_price: totalPrice,
    };
    const res = await dispatch(shipPrvSliceActions.calculateShippingPrice(payload));
    if ((res.payload as any).extra_price.error) return;
    setValue('extra_price', (res.payload as any).extra_price);
    setExtraPrice(prev => prev = (res.payload as any).extra_price);
  }
  return (
    <form className="justify-center gap-6 px-28 h-full max-md:h-auto max-xl:p-4 py-8 grid grid-cols-3 bg-[#F4F4F4] max-md:px-0 max-md:py-4 max-md:grid-cols-1">
      <div className="col-span-2 h-fit bg-white max-md:col-auto">
        <div className="flex gap-2 items-center bg-white text-[#3188FF] border-b-[1px] border-gray-200 border-solid px-2 py-3">
          <BackIcon />
          <Link to="/">Quay lại trang chủ</Link>
        </div>
        <div className="px-3 py-4">
          <div className="flex flex-col gap-3 max-md:gap-4">
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-medium">Thông tin người nhận</h3>
              <div className="flex justify-between flex-wrap gap-5 items-start max-md:flex-col max-md:items-start ">
                <div className="flex flex-col gap-2 flex-1 w-full">
                  <div className="flex gap-2 items-center">
                    <label
                      htmlFor="name"
                      className="text-sm font-normal text-[#46515F]"
                    >
                      Họ và tên
                    </label>
                    <span className="text-xs text-red-500">*</span>
                  </div>
                  <input
                    type="text"
                    id="name"
                    placeholder="Nhập họ tên"
                    spellCheck={false}
                    className={
                      !!errors.full_name
                        ? "border border-red-600 focus:border-red-600 focus:outline-none pl-2 rounded py-2"
                        : "border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2"
                    }
                    {...register("full_name", {
                      required: "Họ và tên không được để trống",
                      pattern: {
                        value:
                          /^[a-zA-Z\sàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸĐ]+$/,
                        message: "Họ và tên không hợp lệ",
                      },
                    })}
                  />
                  {!!errors.full_name && (
                    <p className="text-sm font-normal text-red-600">
                      {errors.full_name.message}
                    </p>
                  )}
                </div>
                <div className="flex flex-col gap-2 flex-1 w-full">
                  <div className="flex gap-2 items-center">
                    <label
                      htmlFor="phone"
                      className="text-sm font-normal text-[#46515F]"
                    >
                      Số điện thoại
                    </label>
                    <span className="text-xs text-red-500">*</span>
                  </div>
                  <input
                    type="tel"
                    id="phone"
                    placeholder="Nhập số điện thoại"
                    className={
                      !!errors.phone
                        ? "border border-red-600 focus:border-red-600 focus:outline-none pl-2 rounded py-2"
                        : "border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2"
                    }
                    {...register("phone", {
                      required: "Số điện thoại không được để trống",
                      pattern: {
                        value: /(((\+|)84)|0)(3|5|7|8|9)([0-9]{8})\b/,
                        message: "Số điện thoại không hợp lệ",
                      },
                    })}
                  />
                  {!!errors.phone && (
                    <p className="text-sm font-normal text-red-600">
                      {errors.phone.message}
                    </p>
                  )}
                </div>
                <div className="flex flex-col gap-2 flex-1 w-full">
                  <label
                    htmlFor="name"
                    className="text-sm font-normal text-[#46515F]"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Nhập email (không bắt buộc)"
                    spellCheck={false}
                    className="border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2"
                    {...register("email")}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex gap-1 items-center">
                <h3 className="text-lg font-medium">Địa chỉ nhận hàng</h3>
                <span className="text-sm text-red-500">*</span>
              </div>
              <div className="flex justify-between gap-7 max-xl:gap-3 items-start max-xl:flex-col max-xl:items-start">
                <div className="flex flex-col gap-2 flex-1 w-full">
                  <select
                    id="province"
                    className={`border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2 ${!!errors.province_id ? "border-red-600" : ""}`}
                    {...register("province_id", {
                      required: "Tỉnh/Thành không được để trống",
                    })}
                    // onChange={fetchWards}
                    defaultValue=""
                  >
                    <option value="" disabled>
                      Tỉnh/Thành
                    </option>
                    {provinceList?.map((province: any) => (
                      <option key={province.province_code} value={province.province_code}>
                        {province.name}
                      </option>
                    ))}
                  </select>
                  {!!errors.province_id && (
                    <p className="text-sm font-normal text-red-600">
                      {errors.province_id.message}
                    </p>
                  )}
                </div>
               
                <div className="flex flex-col gap-2 flex-1 w-full">
                  <select
                    id="district"
                    className={`border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2 ${!!errors.ward_id ? "border-red-600" : ""}`}
                    {...register("ward_id", {
                      required: "Phường/Xã không được để trống",
                    })}
                    onClick={fetchWards}
                    defaultValue=""
                  >
                    <option value="">
                      Phường/Xã
                    </option>
                    {wardList?.map((ward: any) => (
                      <option key={ward.ward_code} value={ward.ward_code}>
                        {ward.name}
                      </option>
                    ))}
                  </select>
                  {!!errors.ward_id && (
                    <p className="text-sm font-normal text-red-600">
                      {errors.ward_id.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex gap-2 items-center">
                <label
                  htmlFor="address"
                  className="text-sm font-normal text-[#46515F]"
                >
                  Địa chỉ
                </label>
                <span className="text-xs text-red-500">*</span>
              </div>
              <input
                type="text"
                id="address"
                placeholder="Số nhà, tên đường"
                spellCheck={false}
                className={
                  !!errors.address
                    ? "border border-red-600 focus:border-red-600 focus:outline-none pl-2 rounded py-2"
                    : "border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2"
                }
                {...register("address", {
                  required: "Địa chỉ không được để trống",
                  onBlur: (ev) => handleCalculateShippingPrice(ev.target.value),
                })}
                aria-invalid={!errors.address}
              />
              {!!errors.address && (
                <p className="text-red-600 text-sm font-normal">
                  {errors.address.message}
                </p>
              )}
            </div>
            <div className="flex flex-col gap-1">
              <label
                htmlFor="note"
                className="text-sm font-normal text-[#46515F]"
              >
                Ghi chú đơn hàng
              </label>
              <input
                type="text"
                id="note"
                spellCheck={false}
                className="border border-[#d8dadc] focus:outline-[#5288FF] pl-2 pb-8 pt-2 rounded "
                {...register("note")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="rounded max-md:px-2">
        <div className="flex justify-between items-center px-3 py-2 border-b-[1px] bg-white border-[#E8EAEB] rounded-t">
          <h3 className="text-lg font-medium">
            Sản phẩm đã chọn ({cartInfo.length})
          </h3>
          <button className="flex items-center text-[#0088FF] hover:bg-[#F5FAFF] p-2 rounded-md">
            <PlusIcon
              width="24"
              height="24"
              backgroundColor="none"
              color="#08F"
            />
            <Link to="/">Mua tiếp</Link>
          </button>
        </div>
        <div className="px-3 relative flex flex-col gap-3 bg-white max-h-[calc(100vh-475px)] overflow-y-auto">
          {!!cartInfo.length &&
            cartInfo.map((item, index) => {
              const unitPrice = getCartItemUnitPrice(item);
              const linePrice = unitPrice * item.quantity;
              const baseLinePrice = item.price_sale * item.quantity;
              const showLineDiscount = unitPrice < item.price_sale;
              return (
                <div key={index} className="flex flex-col gap-2 relative py-2">
                  <div className="flex justify-between gap-5 pt-4 pb-2">
                    <h1 className="text-base">
                      {item.quantity} x {item.name}
                    </h1>
                    <div className="flex items-center gap-2">
                      <p className="text-sm font-normal">
                        {linePrice.toLocaleString("vi-VN")}
                      </p>
                      {showLineDiscount && (
                        <p className="text-xs text-[#7A8086] line-through">
                          {baseLinePrice.toLocaleString("vi-VN")}
                        </p>
                      )}
                    </div>
                  </div>

                  <div
                    className="absolute top-1 -right-1 cursor-pointer"
                    onClick={() =>
                      dispatch(clearProductInCart({ id: item.id }))
                    }
                  >
                    <DeleteIcon />
                  </div>
                </div>
              );
            })}
        </div>
        <div className="p-4 border-t-[1px] border-[#E8EAEB] flex flex-col gap-2 bg-white rounded-b">
          {priceDiscount > 0 &&
            <div className="flex flex-col gap-1">
              <div className="flex justify-end gap-2">
                <p className="text-sm font-normal">Tạm tính:</p>
                <div className="flex items-center gap-2">
                  <h1 className="text-sm font-bold">{totalPrice.toLocaleString("vi-VN")}</h1>
                  {showBaseTotal && (
                    <p className="text-xs text-[#7A8086] line-through">{baseTotalPrice.toLocaleString("vi-VN")}</p>
                  )}
                </div>
              </div>
              <div className="flex justify-end gap-2">
                <div className="flex items-center gap-1">
                  <GiftIcon />
                  <p className="text-sm font-normal">Giảm giá:</p>
                </div>
                <h1 className="text-sm font-bold">
                  {priceDiscount < 100 ? (totalPrice * priceDiscount / 100).toLocaleString("vi-VN") : priceDiscount.toLocaleString("vi-VN")}
                </h1>
              </div>
              {priceDiscount < 100 && <span className="text-right">({priceDiscount}%)</span>}
            </div>
          }
          <div className="flex justify-between items-center gap-4">
            <h2 className="text-base font-medium">Tổng tiền</h2>
            <div className="flex items-center gap-2">
              <p className="text-base font-medium text-red-600">
                {priceDiscount < 100 ? (totalPrice - (totalPrice * priceDiscount / 100)).toLocaleString("vi-VN") : (totalPrice - priceDiscount).toLocaleString("vi-VN")}
              </p>
              {priceDiscount <= 0 && showBaseTotal && (
                <p className="text-xs text-[#7A8086] line-through">{baseTotalPrice.toLocaleString("vi-VN")}</p>
              )}
            </div>
          </div>
          {extraPrice > 0 && <>
            <div className="flex justify-between items-center gap-4">
              <h2 className="text-base font-medium">Phí vận chuyển</h2>
              <p className="text-base font-medium">{extraPrice.toLocaleString("vi-VN")}</p>
            </div>
            <div className="flex justify-between items-center gap-4">
              <h2 className="text-base font-medium">Thanh toán</h2>
              <p className="text-base font-medium">
                {priceDiscount < 100
                  ? ((totalPrice - (totalPrice * priceDiscount / 100)) + extraPrice).toLocaleString("vi-VN")
                  : ((totalPrice - priceDiscount) + extraPrice).toLocaleString("vi-VN")}
              </p>
            </div>
          </>}
          {/* Input enter discount */}
          {isApplyDiscount ?
            <div className="flex justify-between items-center">
              <p className="text-sm font-normal">Đã áp dụng mã giảm giá:<span className="text-blue-600 font-medium"> {discountCode}</span></p>
              <button onClick={() => {
                setIsApplyDiscount(false);
                setDiscountCode('');
                setErrorDiscount('');
                setPriceDiscount(0);
              }}>
                <CloseIcon width="18" height="18" />
              </button>
            </div>
            : <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2 max-lg:flex-col">
                <input
                  className="flex-1 border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2 w-full"
                  placeholder="Mã giảm giá"
                  spellCheck={false}
                  value={discountCode}
                  onChange={(ev) => setDiscountCode(prev => prev = ev.target.value)}
                />
                <button
                  className="flex justify-center items-center py-2 h-[42px] bg-gray-300 rounded-md text-sm font-normal w-1/3 max-lg:w-full disabled:opacity-70 disabled:text-gray-500"
                  disabled={!!!discountCode}
                  onClick={(ev) => {
                    ev.preventDefault();
                    handleCalculateDiscount(discountCode);
                  }}
                >
                  {isLoadingDiscount ? <LoadingIcon width={20} height={20} /> : "Áp dụng"}
                </button>
              </div>
              {errorDiscount && <span className="text-xs text-red-600 font-normal pl-1">{errorDiscount}</span>}
            </div>}
          <div>
            <div className="flex gap-2 items-center">
              <input type="checkbox" id="export_invoice_vat" className="size-4" onChange={(ev) => {
                setIsExportInvoice(ev.target.checked);
              }} />
              <label htmlFor="export_invoice_vat" className="text-sm font-normal">
                Xuất hóa đơn VAT
              </label>
            </div>
            {isExportInvoice && <div>
              <input
                type="text"
                id="vat_id"
                placeholder="Nhập mã số thuế"
                spellCheck={false}
                className="border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2 w-full mt-2"
                {...register("vat_id", {
                  required: "Mã số thuế không được để trống",
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Mã số thuế không hợp lệ",
                  },
                })}
              />
              {!!errors.vat_id && (
                <p className="py-1 pl-1 text-sm font-normal text-red-600">
                  {errors.vat_id.message}
                </p>
              )}
              <input
                type="text"
                id="vat_name"
                placeholder="Nhập tên đơn vị"
                spellCheck={false}
                className="border border-[#d8dadc] focus:outline-[#5288FF] pl-2 rounded py-2 w-full mt-2"
                {...register("vat_name", {
                  required: "Tên đơn vị không được để trống",
                })}
              />
              {!!errors.vat_name && (
                <p className="py-1 pl-1 text-sm font-normal text-red-600">
                  {errors.vat_name.message}
                </p>
              )}
            </div>}
          </div>
          {isLoading ? (
            <button className="flex justify-center items-center bg-[#0088FF] w-full py-2 rounded-md max-md:hidden">
              <LoadingIcon />
            </button>
          )
            : (
              <button
                className={`flex gap-2 justify-center items-center w-full py-2 rounded-md max-md:hidden ${cartInfo.length > 0 ? "bg-[#0088FF] cursor-pointer" : "bg-[#E0E0E0]"}`}
                disabled={!!!cartInfo.length}
                onClick={onSubmit}
              >
                <CheckIcon backgroundColor={cartInfo.length === 0 ? "#FFFFFF" : "#0FD186"} />
                <p className={`text-xl font-normal ${cartInfo.length > 0 ? "text-white" : "text-gray-500"}`}>Đặt đơn</p>
              </button>
            )}
          <p className="text-xs font-normal italic text-center">
            Cửa hàng có thể thu thêm phí vận chuyển sau khi xác nhận đơn hàng,
            tùy theo khu vực giao hàng
          </p>
          {/* Nút đặt hàng trên mobile */}
          <div className="hidden max-md:block bg-white p-4 fixed bottom-0 inset-x-0 border-t border-gray-300 z-10">
            {isLoading
              ? <button className="flex justify-center items-center gap-2 bg-[#0088FF] w-full p-2 rounded-md">
                <LoadingIcon />
              </button>
              : <button
                className={`flex justify-center items-center gap-2 w-full p-2 rounded-md ${cartInfo.length > 0 ? "bg-[#0088FF] cursor-pointer" : "bg-[#E0E0E0]"}`}
                disabled={!!!cartInfo.length}
                onClick={onSubmit}
              >
                <CheckIcon backgroundColor="#FFFFFF" />
                <p className="text-white text-base font-medium">
                  Đặt hàng ({priceDiscount < 100 ? (totalPrice - (totalPrice * priceDiscount / 100) + extraPrice).toLocaleString("vi-VN") : (totalPrice - priceDiscount + extraPrice).toLocaleString("vi-VN")})
                </p>
              </button>}
          </div>
        </div>
      </div>
    </form>
  );
}
